import { lang } from '../../assets/lang'
import { getSelectOptionsFromArrayOfObjects } from '../../utils/functions'
import { 
  languages,
  ctaButtonTextsList,
  actionButtonActionsList, 
  messengerEngagementPluginsList 
} from '../../data'

export const actionButtonHtml =
'<div id="action-button-actions-group" class="form-group text-left mt-2">' + 
  '<label for="action-button-actions">' + lang.action_button_html_title_action_button + '</label>' +
  '<select id="action-button-actions" class="form-control select2">' +
    '<option value="" selected>' + lang.action_button_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(actionButtonActionsList) +
  '</select>' +
'</div>' +

'<div id="action-button-messenger-engagement-plugins-list-group" class="form-group text-left mt-2 d-none">' + 
  '<label for="action-button-messenger-engagement-plugins-list">' + lang.action_button_html_title_messenger_engagement_plugin + '</label>' +
  '<select id="action-button-messenger-engagement-plugins-list" class="form-control select2">' +
    '<option value="" selected>' + lang.action_button_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(messengerEngagementPluginsList) +
  '</select>' +
'</div>' +

'<div id="action-button-messenger-engagement-plugins-group" class="form-group text-left mt-2 d-none">' + 
  '<div class="form-group pb-3 checkbox-plugin send-to-messenger customer-chat-plugin">' +
    '<label class="pb-1">' + lang.action_button_html_domain + '</label>' +
    '<span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="Domain where you want to embed this plugin. domain must have https."> <i class="fas fa-info-circle fa-lg text-primary"></i></span>' +
    '<input type="text" name="domain-name" autocomplete="off" id="domain-name" class="form-control" placeholder="https://example.com">' +
  '</div>' +

  '<div class="form-group pb-3 checkbox-plugin send-to-messenger customer-chat-plugin">' + 
    '<label class="pb-1">' + lang.action_button_html_language + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_language_tooltip + '"></span></label>' +
    '<select id="action-button-messenger-engagement-languages" class="form-control select2">' +
      getSelectOptionsFromArrayOfObjects(languages, 'en_US') +
    '</select>' +
  '</div>' +

  '<div class="form-group pb-3 send-to-messenger">' + 
    '<label class="pb-1">' + lang.action_button_html_cta_button_text + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_cta_button_text_tooltip + '"></span></label>' +
    '<select id="action-button-messenger-engagement-cta-button-texts" class="form-control select2">' +
      '<option value="" selected>Default</option>' +
      getSelectOptionsFromArrayOfObjects(ctaButtonTextsList) +
    '</select>' +
  '</div>' +

  '<div class="form-group pb-3 checkbox-plugin">' +
    '<label class="pb-1">' + lang.action_button_html_plugin_skin + '</label>' +
    '<span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_plugin_skin_tooltip + '"> <i class="fas fa-info-circle fa-lg text-primary"></i></span>' +
    '<div class="row">' +
      '<div class="col-12">' +
        '<div class="selectgroup w-100">' +
          '<label class="selectgroup-item pb-2">' +
            '<input type="radio" name="checkbox-plugin-skin" value="dark" class="selectgroup-input">' +
            '<span class="selectgroup-button">' + lang.action_button_html_plugin_skin_light + '</span>' +
          '</label>' +
          
          '<label class="selectgroup-item pb-2">' +
            '<input type="radio" name="checkbox-plugin-skin" value="light" class="selectgroup-input" checked="">' +
            '<span class="selectgroup-button">' + lang.action_button_html_plugin_skin_dark + '</span>' +
          '</label>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 send-to-messenger">' +
    '<label class="pb-1">' + lang.action_button_html_plugin_skin + '</label>' +
    '<span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_plugin_skin_tooltip + '"> <i class="fas fa-info-circle fa-lg text-primary"></i></span>' +
    '<div class="row">' +
      '<div class="col-12">' +
        '<div class="selectgroup w-100">' +
          '<label class="selectgroup-item pb-2">' +
            '<input type="radio" name="send-to-messenger-plugin-skin" value="white" class="selectgroup-input">' +
            '<span class="selectgroup-button">' + lang.action_button_html_plugin_skin_white + '</span>' +
          '</label>' +
          
          '<label class="selectgroup-item pb-2">' +
            '<input type="radio" name="send-to-messenger-plugin-skin" value="blue" class="selectgroup-input" checked="">' +
            '<span class="selectgroup-button">' + lang.action_button_html_plugin_skin_blue + '</span>' +
          '</label>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 checkbox-plugin">' +
    '<label class="pb-1">' + lang.action_button_html_center_align + '</label>' +
    '<span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_center_align_tooltip + '"> <i class="fas fa-info-circle fa-lg text-primary"></i></span>' +
    '<div class="row">' +
      '<div class="col-12">' +
        '<div class="selectgroup w-100">' +
          '<label class="selectgroup-item pb-2">' +
            '<input type="radio" name="center-align" value="true" class="selectgroup-input" checked="">' +
            '<span class="selectgroup-button"> ' + lang.action_button_html_center_align_yes + '</span>' +
          '</label>' +
          
          '<label class="selectgroup-item pb-2">' +
            '<input type="radio" name="center-align" value="false" class="selectgroup-input">' +
            '<span class="selectgroup-button"> ' + lang.action_button_html_center_align_no + '</span>' +
          '</label>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 checkbox-plugin">' +
    '<label class="pb-1">' + lang.action_button_html_plugin_size + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_plugin_size_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<div class="selectgroup selectgroup-pills">' +
      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="checkbox-plugin-size" value="small" class="selectgroup-input">' +
        '<span class="selectgroup-button">' + lang.action_button_html_plugin_size_small + '</span>' +
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="checkbox-plugin-size" value="medium" checked="" class="selectgroup-input">' +
        '<span class="selectgroup-button">' + lang.action_button_html_plugin_size_medium + '</span>' +
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="checkbox-plugin-size" value="large" class="selectgroup-input">' +
        '<span class="selectgroup-button">' + lang.action_button_html_plugin_size_large + '</span>' +
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="checkbox-plugin-size" value="xlarge" class="selectgroup-input">' +
        '<span class="selectgroup-button">' + lang.action_button_html_plugin_size_xlarge + '</span>' +
      '</label>' +  
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 send-to-messenger">' +
    '<label class="pb-1">' + lang.action_button_html_plugin_size + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_plugin_size_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<div class="selectgroup selectgroup-pills">' +
      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="send-to-messenger-plugin-size" value="standard" checked="" class="selectgroup-input">' +
        '<span class="selectgroup-button">' + lang.action_button_html_plugin_size_standard + '</span>' +
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="send-to-messenger-plugin-size" value="large" class="selectgroup-input">' +
        '<span class="selectgroup-button">' + lang.action_button_html_plugin_size_large + '</span>' +
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="send-to-messenger-plugin-size" value="xlarge" class="selectgroup-input">' +
        '<span class="selectgroup-button">' + lang.action_button_html_plugin_size_xlarge + '</span>' +
      '</label>' +  
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 checkbox-plugin send-to-messenger">' +
    '<label class="custom-switch mt-2">' +
      '<input type="checkbox" name="redirect" id="redirection-status" class="custom-switch-input">' +
      '<span class="custom-switch-indicator"></span>' +
      '<span class="custom-switch-description">' + lang.action_button_html_redirect_to_a_webpage_on_successful_optin + '</span>' +
    '</label>' +
  '</div>' +

  '<div class="form-group pb-3 opt-in-success-message-wrapper checkbox-plugin send-to-messenger">' +
    '<label class="pb-1">' + lang.action_button_html_optin_success_message_in_website + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="This message will be displayed after successful opt-in. Keep it blank if you do not want."><i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<textarea id="opt-in-success-message" class="form-control" placeholder="' + lang.action_button_html_optin_success_message_in_website_textarea_placeholder + '">' + lang.action_button_html_optin_success_message_in_website_textarea_default_message + '</textarea>' +
    '<div class="custom-control custom-checkbox pt-1">' +
      '<input type="checkbox" id="adding-button-in-success-message" class="custom-control-input" name="adding-button-in-success-message">' +
      '<label class="custom-control-label" for="adding-button-in-success-message">' + lang.action_button_html_i_want_to_add_a_button_in_success_message + '</label>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 button-attribute">' +
    '<label>' + lang.action_button_html_button_text + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_button_text_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<input type="text" name="button-text" id="button-text" class="form-control" value="Send Message">' +                     
  '</div>' +

  '<div class="form-group pb-3 button-attribute button-url">' +
    '<label>' + lang.action_button_html_button_url + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_button_url_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<input type="text" name="button-url" id="button-url" class="form-control" value="">' +                     
  '</div>' +

  '<div class="form-group pb-3 button-attribute">' +
    '<label class="pb-1">' + lang.action_button_html_button_background + '</label>' +
    '<div class="input-group color-picker-rgb">' +
      '<input type="text" class="form-control" name="button-bg-color" id="button-bg-color" value="#5CB85C">' +
      '<div class="input-group-append">' +
        '<div class="input-group-text">' +
          '<span class="input-group-addon colorpicker-input-addon"><i style="background-color: rgb(92, 184, 92);"></i></span>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 button-attribute">' +
    '<label class="pb-1">' + lang.action_button_html_button_text_color + '</label>' +
    '<div class="input-group color-picker-rgb">' +
      '<input type="text" class="form-control" name="button-text-color" id="button-text-color" value="#FFFFFF">' +
      '<div class="input-group-append">' +
        '<div class="input-group-text">' +
          '<span class="input-group-addon colorpicker-input-addon"><i style="background-color: rgb(255, 255, 255);"></i></span>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 button-attribute">' +
    '<label class="pb-1">' + lang.action_button_html_button_hover_background + '</label>' +
    '<div class="input-group color-picker-rgb">' +
      '<input type="text" class="form-control" name="button-hover-bg-color" id="button-hover-bg-color" value="#339966">' +
      '<div class="input-group-append">' +
        '<div class="input-group-text">' +
          '<span class="input-group-addon colorpicker-input-addon"><i style="background-color: rgb(51, 153, 102);"></i></span>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 button-attribute">' +
    '<label class="pb-1">' + lang.action_button_html_button_text_hover_color + '</label>' +
    '<div class="input-group color-picker-rgb">' +
      '<input type="text" class="form-control" name="button-hover-text-color" id="button-hover-text-color" value="#FFFDDD">' +
      '<div class="input-group-append">' +
        '<div class="input-group-text">' +
          '<span class="input-group-addon colorpicker-input-addon"><i style="background-color: rgb(255, 253, 221);"></i></span>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

  '<div class="form-group m-me-link">' +
    '<label class="pb-1">' + lang.action_button_html_button_size + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_button_size_tooltip + '"><i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<div class="selectgroup selectgroup-pills">' +
      '<label class="selectgroup-item pb-2">' +
        '<input class="selectgroup-input" type="radio" name="button-size" value="small">' + 
        '<span class="selectgroup-button">' + lang.action_button_html_button_size_small + '</span>' + 
      '</label>' +

      '<label class="selectgroup-item pb-2">' +
        '<input class="selectgroup-input" type="radio" name="button-size" value="medium" checked="">' + 
        '<span class="selectgroup-button">' + lang.action_button_html_button_size_medium + '</span>' + 
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' +
        '<input class="selectgroup-input" type="radio" name="button-size" value="large">' + 
        '<span class="selectgroup-button">' + lang.action_button_html_button_size_large + '</span>' + 
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' +
        '<input class="selectgroup-input" type="radio" name="button-size" value="xlarge">' +
        '<span class="selectgroup-button">' + lang.action_button_html_button_size_extra_large + '</span>' + 
      '</label>' + 
    '</div>' +
  '</div>' +

  '<div id="optin-success-redirect-url" class="form-group pb-3 checkbox-plugin send-to-messenger d-none">' +
    '<label class="pb-1">' + lang.action_button_html_optin_success_redirect_url + '<span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_optin_success_redirect_url_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<input type="text" name="redirection-url-for-successful-optin" id="redirection-url-for-successful-optin" class="form-control" value="">' +                   
  '</div>' +

  '<div class="form-group pb-3 checkbox-plugin">' +
    '<label class="pb-1">' + lang.action_button_html_checkbox_validation_error_message + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_checkbox_validation_error_message_tooltip + '"><i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<textarea name="checkbox-validation-error-message" id="checkbox-validation-error-message" style="width: 100%;" class="form-control"></textarea>' +
  '</div>' +

  '<div class="form-group pb-3 customer-chat-plugin">' +
    '<label>' + lang.action_button_html_chat_plugin_loading + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_chat_plugin_loading_tooltip + '"><i class="fa fa-info-circle fa-lg text-primary"></i> </span></label>' +
    '<div class="selectgroup selectgroup-pills">' +
      '<label class="selectgroup-item pb-2">' +
        '<input class="selectgroup-input" type="radio" name="chat-plugin-loading-status" value="hide">' + 
        '<span class="selectgroup-button">' + lang.action_button_html_chat_plugin_loading_hide + '</span>' +
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' +
        '<input class="selectgroup-input" type="radio" name="chat-plugin-loading-status" value="show" checked="">' + 
        '<span class="selectgroup-button">' + lang.action_button_html_chat_plugin_loading_show + '</span>' +
      '</label>' +
      
      '<label class="selectgroup-item pb-2">' + 
        '<input class="selectgroup-input" type="radio" name="chat-plugin-loading-status" value="fade">' + 
        '<span class="selectgroup-button">' + lang.action_button_html_chat_plugin_loading_fade + '</span>' +
      '</label>' +  
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 customer-chat-plugin">' +
    '<label>' + lang.action_button_html_loading_delay_seconds + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_loading_delay_seconds_tooltip + '" data-original-title="Loading delay"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<input type="number" name="chat-plugin-loading-delay-in-seconds" id="chat-plugin-loading-delay-in-seconds" value="0" class="form-control" min="0" step="1">' +           
  '</div>' +

  '<div class="form-group pb-3 customer-chat-plugin">' +
    '<label class="pb-1">' + lang.action_button_html_theme_color + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_theme_color_tooltip + '"><i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<div class="input-group color-picker-rgb">' +
      '<input type="text" class="form-control" name="theme-color" id="theme-color" value="#FFFFFF">' +
      '<div class="input-group-append">' +
        '<div class="input-group-text">' +
          '<span class="input-group-addon colorpicker-input-addon"><i style="background-color: rgb(255, 255, 255);"></i></span>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 d-none">' +
    '<label>' + lang.action_button_html_do_not_show_if_not_logged_in + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_do_not_show_if_not_logged_in_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<div class="selectgroup w-100">' +
      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="hide-chat-plugin-if-not-logged-in" value="1" class="selectgroup-input">' +
        '<span class="selectgroup-button">' + lang.action_button_html_do_not_show_if_not_logged_in_yes + '</span>' +
      '</label>' +

      '<label class="selectgroup-item pb-2">' +
        '<input type="radio" name="hide-chat-plugin-if-not-logged-in" value="0" class="selectgroup-input" checked="">' +
        '<span class="selectgroup-button">' + lang.action_button_html_do_not_show_if_not_logged_in_no + '</span>' +
      '</label>' +
    '</div>' +
  '</div>' +

  '<div class="form-group pb-3 customer-chat-plugin">' +
    '<label>' + lang.action_button_html_greeting_text_if_logged_in_to_facebook + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_greeting_text_if_logged_in_to_facebook_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<input type="text" name="greeting-text-if-logged-in" id="greeting-text-if-logged-in" class="form-control" placeholder="' + lang.action_button_html_greeting_text_if_logged_in_to_facebook_placeholder + '">' + 
  '</div>' +

  '<div class="form-group pb-3 customer-chat-plugin">' +
    '<label>' + lang.action_button_html_greeting_text_if_not_logged_in_to_facebook + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_greeting_text_if_not_logged_in_to_facebook_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<input type="text" name="greeting-text-if-not-logged-in" id="greeting-text-if-not-logged-in" class="form-control" placeholder="' + lang.action_button_html_greeting_text_if_not_logged_in_to_facebook_placeholder + '">' +  
  '</div>' +

  '<div class="form-group pb-3 checkbox-plugin send-to-messenger m-me-link customer-chat-plugin">' +
    '<label>' + lang.action_button_html_reference + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_reference_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<input type="text" name="reference" id="reference" class="form-control" value="">' +                     
  '</div>' +

  '<div class="form-group pb-3 checkbox-plugin send-to-messenger m-me-link customer-chat-plugin">' +
    '<label class="pb-1">' + lang.action_button_html_select_labels + ' <span style="font-size: 0.6rem;" data-toggle="tooltip" data-original-title="' + lang.action_button_html_select_labels_tooltip + '"> <i class="fa fa-info-circle fa-lg text-primary"></i></span></label>' +
    '<select id="label-ids" class="form-control select2" multiple="">' +
    '</select>' +
  '</div>' +

'</div>' 

